<template>
  <div class="reply-group-list">
    <el-card v-for="problem in groups" :key="problem.problemId || problem.problemName" class="reply-group-card" shadow="never">
      <div class="problem-header">
        <div class="problem-title">{{ problem.problemName }}</div>
        <div class="problem-tags">
          <el-tag v-if="categoryName(problem)" size="mini" type="info">{{ categoryName(problem) }}</el-tag>
          <el-tag v-if="problem.sensitive" size="mini" type="danger">敏感问题</el-tag>
        </div>
      </div>
      <el-tooltip v-if="problem.games && problem.games.length" :content="gameText(problem)" placement="top-start" popper-class="reply-game-tooltip">
        <div class="game-line">{{ gameText(problem) }}</div>
      </el-tooltip>
      <div v-for="answer in visibleAnswers(problem)" :key="answer.clientId" class="reply-answer-item">
        <div class="answer-text">{{ answer.value }}</div>
        <div class="answer-actions">
          <el-button v-if="answer.canCopy !== false" size="mini" type="primary" :loading="answer.status === 'sending'" @click="$emit('copyToInput', answer, problem)">复制到输入框</el-button>
          <el-tag v-if="answer.status === 'failed'" size="mini" type="danger">发送失败</el-tag>
        </div>
      </div>
      <el-button v-if="problem.answers.length > 1" type="text" size="mini" @click="toggle(problem)">
        {{ expanded[key(problem)] ? '收起其余话术' : `展开其余 ${problem.answers.length - 1} 条话术` }}
      </el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ReplyGroupList',
  props: { groups: { type: Array, default: () => [] } },
  data: () => ({ expanded: {} }),
  methods: {
    key(problem) { return String(problem.problemId || problem.problemName); },
    categoryName(problem) {
      const category = problem.secondaryCategory || problem.primaryCategory;
      return category && category.name ? category.name : '';
    },
    gameText(problem) { return `适用游戏：${problem.games.map(item => item.name).join('、')}`; },
    visibleAnswers(problem) { return this.expanded[this.key(problem)] ? problem.answers : problem.answers.slice(0, 1); },
    toggle(problem) {
      const expanded = !this.expanded[this.key(problem)];
      this.$set(this.expanded, this.key(problem), expanded);
      if (expanded) this.$emit('expand', problem);
    },
  },
};
</script>

<style lang="scss" scoped>
.reply-group-list { margin-top: 12px; }
.reply-group-card { margin-bottom: 10px; border-radius: 8px; }
.problem-header { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.problem-title { font-size: 15px; font-weight: 600; color: #303133; }
.problem-tags { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.game-line { margin-top: 6px; overflow: hidden; color: #909399; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.reply-answer-item { padding: 12px; margin-top: 10px; background: #f8f9ff; border-radius: 6px; }
.answer-text { font-size: 13px; color: #303133; line-height: 1.6; white-space: pre-wrap; word-break: break-word; }
.answer-actions { display: flex; align-items: center; gap: 8px; margin-top: 10px; }
</style>

<style lang="scss">
.reply-game-tooltip {
  max-width: 360px;
  max-height: 240px;
  overflow-y: auto;
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
}
</style>
